import { useMemo } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { type AnalyticsAttributes } from '@atlassian/analytics-bridge';

import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider.tsx';

export const useAiIssueCreateAnalytics = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const [{ pageMode, hasEditPermission }] = useIssueCreateSidePanelContext();

	return useMemo(
		() => ({
			fireTrack: (name: string, attributes?: AnalyticsAttributes) => {
				const source = 'aiIssueCreate';
				const [actionSubject, action] = name.split(' ');
				const eventAttributes = { pageMode, hasEditPermission, ...attributes };
				createAnalyticsEvent({
					type: 'sendOperationalEvent',
					data: { source, action, actionSubject, attributes: eventAttributes },
				}).fire();
			},
		}),
		[createAnalyticsEvent, pageMode, hasEditPermission],
	);
};
